var _a;
import { AccountType } from "./getAccountType";
export var label = (_a = {},
    _a[AccountType.CARD] = "accountEndingIn",
    _a[AccountType.SECURED_INSTALLMENT_LOAN] = "loanEndingIn",
    _a[AccountType.LOAN] = "loanEndingIn",
    _a[AccountType.PAY_IN_4] = "loanEndingIn",
    _a);
export var cardHeaderLabel = function (type) {
    if (type === void 0) { type = AccountType.LOAN; }
    return label[type];
};
//# sourceMappingURL=cardHeaderLabel.js.map